import { Docs } from "./Docs";

export function OrbHowTo() {
  return <Docs slug="orb" />;
}
